<div class="d-flex justify-content-between align-items-center">
  <h3 class="course-heading text-start fw-bold">Course Resources</h3>
</div>
<p class="sub-head text-start">
  Add textbooks and web links that students can use for learning.
</p>
<form [formGroup]="resourcesForm" class="resources-wrapper">
  <!--  TEXTBOOKS SECTION -->
  <div class="section">
    <div class="section-row">
      <span class="section-title">Textbooks</span>
    </div>

    <!-- Show this button only when no textbooks added and form is hidden -->
    <button type="button" class="add-btn-inline full-width" (click)="toggleAddTextbook()" *ngIf="!addTextbookVisible ">
      <span class="plus-icon"><i class="bi bi-plus"></i></span>
      Add Textbook
    </button>

    <!-- Add New Textbook Form -->
    <div class="add-textbook-container" *ngIf="addTextbookVisible">
      <div class="add-textbook-header">
        <h3>Add New Textbook</h3>
        <button type="button" class="collapse-btn" (click)="toggleAddTextbook()"><i
            class="bi bi-caret-up-fill"></i></button>
      </div>

      <form [formGroup]="textbookForm" class="textbook-form">
        <div class="form-row">
          <div class="form-group">
            <label>Title <span>*</span></label>
            <input formControlName="title" placeholder="Book title" />
            <div class="error" *ngIf="textbookForm.get('title')?.touched && textbookForm.get('title')?.invalid">
             invalid data
            </div>
          </div>

          <div class="form-group">
            <label>Author <span>*</span></label>
            <input formControlName="author" placeholder="Author name" />
            <div class="error" *ngIf="textbookForm.get('author')?.touched && textbookForm.get('author')?.invalid">
              invalid data
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Publisher <span>*</span></label>
            <input formControlName="publisher" placeholder="Publisher" />
            <div class="error" *ngIf="textbookForm.get('publisher')?.touched && textbookForm.get('publisher')?.invalid">
              invalid data
            </div>
          </div>
          <div class="form-group">
            <label>Year</label>
            <input type="number" formControlName="year" placeholder="YYYY" />
              <div class="error" *ngIf="textbookForm.get('year')?.touched && textbookForm.get('year')?.invalid">

              <span *ngIf="textbookForm.get('year')?.errors?.['required']">
                Year is required
              </span>

              <span *ngIf="textbookForm.get('year')?.errors?.['pattern']">
                Year must be 4 digits
              </span>

              <span *ngIf="textbookForm.get('year')?.errors?.['futureYear']">
                Year cannot be in the future
              </span>
            </div>
          </div>
        </div>

        <div class="action-row">
          <button type="button" class="delete-btn" (click)="cancelAddTextbook()">
            <i class="bi bi-trash"></i> Delete
          </button>
          <button type="button" class="save-btn" (click)="saveTextbook()">
            <i class="bi bi-floppy2-fill"></i> Save Textbook
          </button>
        </div>
      </form>

      <!-- saved -->

    </div>
    <!-- Saved Textbooks Preview -->
    <div class="saved-resources" *ngIf="textbooks.length > 0">
      <div class="resource-item" *ngFor="let book of textbooks; let i = index">
        <span class="resource-count">{{ i + 1 }}</span>
        <div class="resource-details">
          <div class="book-name">{{ book.title }}</div>
          <div class="book-meta">
            {{ book.author }} | {{ book.publisher }} | {{ book.year }}
          </div>
        </div>
        <div class="action-icons">
          <button type="button" class="icon-btn edit-btn" (click)="editTextbook(i)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="icon-btn delete-btn" (click)="deleteTextbook(i)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>

  </div>

  <!--  WEB RESOURCES SECTION (unchanged) -->
  <div class="section">
    <div class="section-row">
      <span class="section-title">Web Resources</span>
    </div>

    <button type="button" class="add-btn-inline full-width" (click)="toggleAddWebResource()"
      *ngIf="!addWebResourceVisible">
      <span class="plus-icon"><i class="bi bi-plus"></i></span>
      Add Web Resource
    </button>

    <div class="add-textbook-container" *ngIf="addWebResourceVisible">
      <div class="add-textbook-header">
        <h3>Add Web Resource</h3>
        <button type="button" class="collapse-btn" (click)="toggleAddWebResource()"><i
            class="bi bi-caret-up-fill"></i></button>
      </div>

      <form [formGroup]="webResourceForm" class="textbook-form">
        <div class="form-row">
          <div class="form-group">
            <label>URL <span>*</span></label>
            <input formControlName="url" placeholder="https://example.com" />
          </div>
        </div>

        <div class="action-row">
          <button type="button" class="delete-btn" (click)="cancelAddWebResource()"><i class="bi bi-trash"></i>
            Delete</button>
          <button type="button" class="save-btn" (click)="saveWebResource()"><i class="bi bi-floppy2-fill"></i> Save
            Resource</button>
        </div>
      </form>
    </div>
    <div class="saved-resources" *ngIf="webResources.length > 0">
      <div class="resource-item" *ngFor="let resource of webResources; let i = index">
        <span class="resource-count">{{ i + 1 }}</span>
        <div class="resource-details">
          <div class="book-meta">{{ resource }}</div>
        </div>
        <div class="action-icons">
          <button type="button" class="icon-btn edit-btn" (click)="editWebResource(i)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="icon-btn delete-btn" (click)="deleteWebResource(i)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>

  </div>
</form>



<div class="d-flex justify-content-between align-items-center">
  <button type="button" class="btn-cancel py-2 mt-2" (click)="goToPrePage()">
    <mat-icon class="icon-middle me-2">chevron_left</mat-icon> Previous
  </button>

  <button type="submit" class="btn-add mb-2" (click)="goToNextPage()"> Preview Course <mat-icon
      class="icon-middle">chevron_right</mat-icon>
  </button>
</div>